import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "flex flex-col w-full bg-brand-black my-auto px-4 pb-6 pt-14 z-50" }
const _hoisted_2 = { class: "flex flex-col space-y-6" }
const _hoisted_3 = { class: "flex flex-col w-full space-y-2" }
const _hoisted_4 = {
  key: 0,
  class: "flex text-white text-2xl font-medium"
}
const _hoisted_5 = {
  key: 1,
  class: "flex text-white text-2xl font-medium"
}
const _hoisted_6 = { class: "flex flex-col space-y-2" }
const _hoisted_7 = { class: "flex flex-col space-y-4" }
const _hoisted_8 = { class: "flex m-auto space-x-2.5" }
const _hoisted_9 = { class: "my-auto pt-0.5" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("svg", {
  class: "animate-spin h-5 w-5 text-brand-black",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    class: "opacity-25",
    cx: "12",
    cy: "12",
    r: "10",
    stroke: "currentColor",
    "stroke-width": "4"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    class: "opacity-75",
    fill: "currentColor",
    d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
  })
], -1)
const _hoisted_13 = [
  _hoisted_12
]

import {
  IonContent, IonFooter,
  IonPage, IonToolbar, onIonViewDidEnter, onIonViewWillEnter, useIonRouter,
} from '@ionic/vue';
import {computed, defineComponent, onMounted, ref} from 'vue';
import InputCheckbox from "@/components/InputCheckbox.vue";
import ApiService from "@/services/api/apiService";
import {PreferenceKey} from "@/definitions/PreferenceKey";
import {Observable, ObservableEvent} from "@/services/observable/Observable";
import {Preferences} from "@capacitor/preferences";
import {AccountType} from "@/definitions/AccountType";


export default /*#__PURE__*/_defineComponent({
  __name: 'AccountOnboardingInterestedInPage',
  setup(__props) {

const loading = ref(false)
const busy = ref(false)
const interests = ref([])

const errors = ref({})
const ionRouter = useIonRouter()
const accountType = ref()

onIonViewWillEnter(async () => {
  Observable.emit(ObservableEvent.IonRouterOutletChanged, ionRouter.canGoBack())
  accountType.value = (await Preferences.get({key: PreferenceKey.OnboardingAccountType})).value
})

onMounted(async () => {
  await getSexualityOptions()
  loading.value = false
})

const getSexualityOptions = async () => {
  interestOptions.value = (await ApiService.Settings().getSexualities()).map((g: any) => {
    return {
      text: g.name,
      value: g.id
    }
  })
}

const forward = async () => {
  if (!interests.value.length || busy.value) return
  busy.value = true
  try {
    await ApiService.User().setSexualInterests(interests.value.join(','))
    await ApiService.User().setPreference(PreferenceKey.ProfileShowSexualInterests, showOnProfile.value[0])
    await ionRouter.navigate('/account/onboarding/looking-for', 'forward', 'push')
  } catch (e: any) {
    if (!e.data) return
    if (e.data.errors) errors.value = e.data.errors
  } finally {
    busy.value = false
  }
}

const canProgress = computed(() => {
  return !interests.value.length
})

const interestOptions: any = ref([])
const showOnProfile: any = ref([true])



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonContent), null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                (accountType.value === _unref(AccountType).Individual)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, "I'm interested in"))
                  : _createCommentVNode("", true),
                (accountType.value === _unref(AccountType).Joint)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, "We're interested in"))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(interestOptions.value, (s, sIndex) => {
                  return (_openBlock(), _createBlock(InputCheckbox, {
                    key: sIndex,
                    name: "interests",
                    modelValue: interests.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((interests).value = $event)),
                    option: s
                  }, null, 8, ["modelValue", "option"]))
                }), 128))
              ])
            ])
          ])
        ]),
        _: 1
      }),
      _createVNode(_unref(IonFooter), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonToolbar), null, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_7, [
                _createVNode(InputCheckbox, {
                  name: "display",
                  modelValue: showOnProfile.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((showOnProfile).value = $event)),
                  "input-type": "toggle",
                  option: {
              text: 'Show on my profile',
              value: true
            }
                }, null, 8, ["modelValue"]),
                _createElementVNode("button", {
                  onClick: forward,
                  class: _normalizeClass([{
              'bg-opacity-40' : canProgress.value
            }, "flex w-full bg-brand-lime rounded-full px-8 h-14 font-medium text-xl text-brand-black transition-all"])
                }, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      (!busy.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_10, "Continue"))
                        : _createCommentVNode("", true),
                      (busy.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_11, _hoisted_13))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ], 2)
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})